var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 15L6.19375 9.625C5.57074 8.88942 5.16953 7.99197 5.03685 7.03718C4.90417 6.08239 5.04547 5.10955 5.44432 4.23197C5.84316 3.35439 6.48312 2.60818 7.28966 2.08024C8.09621 1.55231 9.03614 1.26439 10 1.25C11.3361 1.2632 12.6125 1.80537 13.5497 2.75776C14.4868 3.71015 15.0083 4.99512 15 6.33125C15.0005 7.49683 14.6037 8.62778 13.875 9.5375L10 15ZM10 2.5C8.99491 2.51154 8.03548 2.92149 7.33238 3.63982C6.62929 4.35815 6.24 5.32614 6.25 6.33125C6.25419 7.24864 6.58424 8.13469 7.18125 8.83125L10 12.825L12.8937 8.75C13.4438 8.0634 13.7456 7.211 13.75 6.33125C13.76 5.32614 13.3707 4.35815 12.6676 3.63982C11.9645 2.92149 11.0051 2.51154 10 2.5Z",
    fill: "#012749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.875C10.6904 6.875 11.25 6.31536 11.25 5.625C11.25 4.93464 10.6904 4.375 10 4.375C9.30964 4.375 8.75 4.93464 8.75 5.625C8.75 6.31536 9.30964 6.875 10 6.875Z",
    fill: "#012749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.5H16.25V8.75H17.5V17.5H2.5V8.75H3.75V7.5H2.5C2.16848 7.5 1.85054 7.6317 1.61612 7.86612C1.3817 8.10054 1.25 8.41848 1.25 8.75V17.5C1.25 17.8315 1.3817 18.1495 1.61612 18.3839C1.85054 18.6183 2.16848 18.75 2.5 18.75H17.5C17.8315 18.75 18.1495 18.6183 18.3839 18.3839C18.6183 18.1495 18.75 17.8315 18.75 17.5V8.75C18.75 8.41848 18.6183 8.10054 18.3839 7.86612C18.1495 7.6317 17.8315 7.5 17.5 7.5Z",
    fill: "#012749"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3edbd21e1dcc2cd0ca49fae82895c0ac.svg";
export { ForwardRef as ReactComponent };